/*
 * Copyright (c) 2018. Viscomp LLC. All rights are reserved!
 */

/**
 * Contains initialization logic for page galleries.
 */

const PagingGallery = require("./Gallery/Paging");
import InfinityScrollGallery from "./Gallery/InfinityScroll";
import Router from "./Gallery/Router";
function initGalleriesElements(context) {
  let galleriesElements = context.querySelectorAll("[data-gallery-element]");
  for (let i = 0; i < galleriesElements.length; i++) {
    let galleryEl = galleriesElements[i];
    let galleryType = galleryEl.getAttribute("data-gallery-element-type");
    let ajaxLoading = galleryEl.getAttribute("data-gallery-ajax-loading");
    let totalImages = galleryEl.querySelectorAll("[data-imagegallery] [data-image-visible]").length;
    let itemsPerPage = galleryEl.getAttribute("data-gallery-items-per-page");
    if (totalImages === 0) {
      continue;
    }

    // PAGING
    // =============================================================

    if (galleryType === "Paging") {
      new PagingGallery(galleryEl, {
        totalImages: totalImages,
        imagesPerPage: parseInt(itemsPerPage, 10),
        ajaxLoading: ajaxLoading === "true"
      });
    }

    // INFINITE SCROLL
    // =============================================================
    if (galleryType === "LazyLoading") {
      new InfinityScrollGallery(galleryEl, {});
    }
  }
}
const initGalleries = function () {
  initGalleriesElements(document);
};
export { initGalleriesElements, initGalleries };